export default "__VITE_ASSET__BDB4APYS__"